import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Center, Spinner } from '@chakra-ui/react';
import { useUser } from '@utils/hooks/queries';

const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();
  const { user, isLoading: loadingUser } = useUser();
  const location = useLocation();

  if (loading || loadingUser) {
    return <Center h="100vh"><Spinner /></Center>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  const onboardingStep = user?.onboarding_step;
  const isOnboarding = location.pathname === '/onboarding';

  // Only redirect to onboarding when the profile is actually loaded and genuinely incomplete.
  // Guarding on `user` avoids bouncing an authenticated user to /onboarding when `/users` is
  // momentarily unavailable (undefined); `!= null` keeps legacy null-step users on dashboard.
  if (!isOnboarding && user && onboardingStep != null && onboardingStep !== 'welcome') {
    return <Navigate to="/onboarding" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
